export default __webpack_public_path__ + "static/media/bounty.cbe2ff25.png";